<div class="modal-header">
  <h4 class="modal-title" id="myModalLabel1">İşlemi Güncelle</h4>
  <button type="button" class="close" (click)="closeModal()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" tabindex="12" ngbAutofocus>
  <form #transactionForm="ngForm">
    <div class="row">
      <div class="form-group col-9">
        <label for="customSelect">İş Emirleri</label>
        <select [(ngModel)]="transactionManagement.requestTaskTransaction.requestTaskId" class="form-control"
          id="customSelect" name="requestTaskId">
          <option *ngFor="let item of transactionManagement?.requestTasks" [value]="item.id"
            [selected]="item.id == transactionManagement.requestTaskTransaction?.requestTaskId">
            {{item.title}} ({{item.no}}) {{item.startDate | date:'dd/MM/yyyy' }}
          </option>
        </select>
      </div>
      <div class="form-group col-3">
        <label for="documentNo">No</label>
        <input type="text" id="documentNo" name="documentNo" [(ngModel)]="transactionManagement.documentNo"
          class="form-control" placeholder="Teklif No" maxlength="16" />
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <label for="customSelect">Sorumlu Kişi</label>
        <div class="form-group">
          <select class="form-control" id="customSelect" [(ngModel)]="transactionManagement.personId" name="personId">
            <option *ngFor="let item of transactionManagement?.persons" [value]="item.id">
              {{item.name}} {{item.lastName}} ({{item.mission}})
            </option>
          </select>
        </div>
      </div>

      <div class="form-group col-6">
        <label for="customSelect">Açıklama Seç</label>
        <select class="form-control" id="customSelect" (change)="onDescriptionChange($event)">
          <option [value]="null">Açıklama Seç</option>
          <option *ngFor="let item of descriptions" [value]="item.id"
            [selected]="item.id === transactionManagement!.transactionManagementDescriptionConnect[0]?.transactionManagementDescriptionId">
            {{item.title}}
          </option>
        </select>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-6">
        <label>Oluşturma Tarihi</label>
        <ng2-flatpickr [config]="dateTimeStartOptions" [setDate]="transactionManagement.transactionCraetedAt"
          [(ngModel)]="transactionManagement.transactionCraetedAt" name="startDate"></ng2-flatpickr>
      </div>

      <div class="form-group col-6">
        <label>Bitiş Tarihi</label>
        <ng2-flatpickr [config]="dateTimeEndOptions" [setDate]="transactionManagement.validityDate"
          [(ngModel)]="transactionManagement.validityDate" name="endDate"></ng2-flatpickr>
      </div>

      <div class="col-6" *ngIf="project?.length > 0">
        <label for="customSelect">Proje Seçin</label>
        <div class="form-group">
          <select class="form-control" id="customSelect" (change)="onProjectChange($event)" name="projectId">
            <!-- Default option -->
            <option [ngValue]="null">Proje Seçin</option>

            <!-- Options from the project list -->
            <option *ngFor="let item of project" [value]="item.id"
              [selected]="item.id == this.transactionManagement?.project[0]?.projectId">
              {{item.name}}
            </option>
          </select>
        </div>
      </div>

      <div class="form-group col-6" *ngIf="transactionManagement!.expenseTransactions?.length > 0">
        <label for="customSelect">Masraf kalemi Seçin</label>
        <select class="form-control" id="customSelect" (change)="onTransactionExpenseChange($event)">
          <option [value]="null">Masraf kalemi Seç</option>
          <option *ngFor="let item of expenses" [value]="item.id"
            [selected]="item.id === transactionManagement!.expenseTransactions[0]?.expenseId">
            {{item.name}} - {{item.typeName}}
          </option>
        </select>
      </div>
    </div>
    <div>
      <label>Müşteri Notu</label>
      <div class="form-group">
        <textarea class="form-control" [(ngModel)]="transactionManagement.transactionPrivateNode"
          name="description"></textarea>
      </div>
    </div>
  </form>
  <div class="row">
    <button type="button" class="btn btn-success ml-auto mr-1" (click)="updateTransactionManagement()"
      *ngIf="authService.isEndpointStatus('PUT.Updateing.UpdateTransactions')">Güncelle</button>
  </div>
</div>